export default __webpack_public_path__ + "static/media/Energy_disabled.82ff3349.jpg";